import styled from 'styled-components';
import Link from '@material-ui/core/Link';
import ReceiptIcon from '@material-ui/icons/Receipt';

import THEME from '../../../../../constants/theme';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  max-width: 872px;
  width: 100%;
`;

export const Space = styled.div`
  flex: 1;
`;

export const OrderLink = styled(Link)`
  color: ${THEME.primary};
  cursor: pointer;
  justify-self: center;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0.2px;
  margin: 0px 0px 0px 20px;
  min-width: 120px;
`;

export const Icon = styled(ReceiptIcon)`
  height: 13px;
`;
